const $ = jQuery.noConflict();
import lottieWeb from 'lottie-web';

'use strict';

const Animations = {
	/**
	* @description Cache dom and strings
	* @type {object}
	*/

	/** @description Initialize */
	init: function() {
		this.animationSetup();
	},
	/** @description */

	animationSetup() {
		const lazyLoaderImg = document.getElementById('anim-preloader');
		const animContainer = document.getElementById('anim-container');

		if (animContainer) {
			const anim = lottieWeb.loadAnimation({
				container: animContainer,
				renderer: 'svg',
				path: '../wp-content/themes/fws-northpoint/src/animations/hero-animation.json',
				loop: false,
				rendererSettings: {
					progressiveLoad: true, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
				},
			});

			// animation preloader
			anim.addEventListener('data_ready', function() {
				if (lazyLoaderImg) {
					lazyLoaderImg.remove();
				}
				$('#anim-container svg').attr('preserveAspectRatio', 'xMidYMid slice');
			});
		}
	}
};

export default Animations;
